var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-margin" }, [
    !_vm.customerInfo
      ? _c(
          "button",
          {
            staticClass: "btn-customer col row no-margin",
            on: {
              click: function($event) {
                return _vm.setPosSection("customers")
              }
            }
          },
          [
            _c("div", { staticClass: "col-10 text-left" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.nocustomerselected")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      : _c(
          "button",
          {
            staticClass: "btn-customer col row no-margin",
            on: {
              click: function($event) {
                return _vm.setPosSection("customers")
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-10 text-left selected text-success" },
              [
                _c("i", {
                  staticClass: "fas fa-check",
                  staticStyle: { "margin-right": "3px" }
                }),
                _vm._v(
                  "\n      " + _vm._s(_vm.customerInfo.customer_name) + "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 text-right" }, [
      _c("i", { staticClass: "fas fa-angle-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 text-right" }, [
      _c("i", { staticClass: "fas fa-angle-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8f81ec4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8f81ec4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/CustomerButton.vue
// module id = null
// module chunks = 